(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["basico-faq-new"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function openAcc(btn) {
    var body = btn.nextElementSibling;
    if (!body) return;
    btn.classList.add('active');
    btn.setAttribute('aria-expanded', 'true');
    body.style.maxHeight = body.scrollHeight + 'px';
  }

  function closeAcc(btn) {
    var body = btn.nextElementSibling;
    if (!body) return;
    btn.classList.remove('active');
    btn.setAttribute('aria-expanded', 'false');
    body.style.maxHeight = null;
  }

  function closeAllExcept(current, panel) {
    panel.querySelectorAll('.basico-faq-new__heading').forEach(function (b) {
      if (b !== current) closeAcc(b);
    });
  }

  function openFirst(panel) {
    var first = panel.querySelector('.basico-faq-new__heading');
    if (!first) return;
    setTimeout(function () { openAcc(first); }, 80);
  }

  function updateScrollIndicator(scroll, thumb) {
    var scrollLeft = scroll.scrollLeft;
    var scrollWidth = scroll.scrollWidth;
    var clientWidth = scroll.clientWidth;
    var maxScroll = scrollWidth - clientWidth;
    if (maxScroll <= 0) {
      thumb.style.width = '100%';
      thumb.style.left = '0%';
      return;
    }
    var thumbWidth = Math.max(20, (clientWidth / scrollWidth) * 100);
    var thumbLeft = (scrollLeft / maxScroll) * (100 - thumbWidth);
    thumb.style.width = thumbWidth + '%';
    thumb.style.left = thumbLeft + '%';
  }

  function switchTab(key) {
    document.querySelectorAll('.basico-faq-new__tab-btn').forEach(function (btn) {
      var on = btn.dataset.tab === key;
      btn.classList.toggle('active', on);
      btn.setAttribute('aria-selected', String(on));
    });
    document.querySelectorAll('.basico-faq-new__panel').forEach(function (p) {
      p.classList.remove('active');
    });
    var target = document.getElementById('basico-panel-' + key);
    if (target) {
      target.classList.add('active');
      target.querySelectorAll('.basico-faq-new__heading').forEach(closeAcc);
      openFirst(target);
    }
  }

  function showBar(track) {
    clearTimeout(track._bfnTimer);
    track.classList.add('is-active');
    track._bfnTimer = setTimeout(function () {
      track.classList.remove('is-active');
    }, 1200);
  }

  function init() {
    document.querySelectorAll('.basico-faq-new').forEach(function (section) {
      var scroll = section.querySelector('.basico-faq-new__tabs-scroll');
      var thumb = section.querySelector('.basico-faq-new__tabs-thumb');
      var track = section.querySelector('.basico-faq-new__tabs-track');

      if (scroll && thumb && track) {
        updateScrollIndicator(scroll, thumb);
        scroll.addEventListener('scroll', function () {
          updateScrollIndicator(scroll, thumb);
          showBar(track);
        });
        scroll.addEventListener('mouseenter', function () {
          updateScrollIndicator(scroll, thumb);
          showBar(track);
        });
        scroll.addEventListener('mouseleave', function () {
          clearTimeout(track._bfnTimer);
          track._bfnTimer = setTimeout(function () {
            track.classList.remove('is-active');
          }, 600);
        });
        window.addEventListener('resize', function () {
          updateScrollIndicator(scroll, thumb);
        });
      }
    });

    document.querySelectorAll('.basico-faq-new__tab-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var track = this.closest('.basico-faq-new__tabs-track');
        if (track) showBar(track);
        if (!this.classList.contains('active')) switchTab(this.dataset.tab);
      });
    });

    document.querySelectorAll('.basico-faq-new__panel').forEach(function (panel) {
      panel.querySelectorAll('.basico-faq-new__heading').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var parentPanel = this.closest('.basico-faq-new__panel');
          if (this.classList.contains('active')) { closeAcc(this); }
          else { closeAllExcept(this, parentPanel); openAcc(this); }
        });
      });
    });

    var active = document.querySelector('.basico-faq-new__panel.active');
    if (active) openFirst(active);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
